import { PagedFilter, DaysOfWeek, GeoLocation } from '../common/common.types';
import { EventBase } from '../meta/event-bases/event-base.types';
import { MetaStatus } from '../meta/meta.types';
import { Moment } from 'moment';

export class PriceMatrixFilter extends PagedFilter {
	searchTerm?: string;
	currencyCode?: string;
	statuses?: MetaStatus[];
	eventBaseIds?: number[];
}

export class PriceMatrixSummary {
	priceMatrixId: number;
	status: MetaStatus;
	name: string;
	currencyCodes: string[];
	eventBases: EventBase[];
}

export enum HolidaySurchargeType {
	Percent = 1,
	Flat = 2
}

export class PriceMatrix {
	priceMatrixId: number;
	status: MetaStatus;
	name: string;

	hasAttendees: boolean;
	minAttendees?: number;
	perAttendees?: number;
	maxAttendees?: number;

	hasDuration: boolean;
	minDuration?: number;
	perDuration?: number;
	maxDuration?: number;

	hasResources: boolean;
	minResources?: number;
	maxResources?: number;

	locations: PriceMatrixLocation[];
}

export class PriceMatrixLocation {
	priceMatrixLocationId: number;
	eventBase: EventBase;

	isPrimary: boolean;
	hasDailyRates: boolean;
	hasHolidayRates: boolean;
	holidaySurcharge?: number;
	holidaySurchargeType?: HolidaySurchargeType;

	hasDistance: boolean;
	minDistance?: number;
	perDistance?: number;
	maxDistance?: number;

	hasTravel: boolean;
	minTravel?: number;
	perTravel?: number;
	maxTravel?: number;

	items: PriceMatrixItem[];
}

export class PriceMatrixItem {
	priceMatrixItemId: number;

	minAttendees?: number;
	maxAttendees?: number;
	resources?: number;
	daysOfWeek?: DaysOfWeek[];

	flatRate?: number;
	attendeeRate?: number;
	durationRate?: number;
	distanceRate?: number;
	travelRate?: number;
}

export class PriceMatrixWM {
	name: string;

	minAttendees?: number;
	perAttendees?: number;
	maxAttendees?: number;

	minDuration?: number;
	perDuration?: number;
	maxDuration?: number;

	minResources?: number;
	maxResources?: number;

	locations?: PriceMatrixLocationWM[];
}


export class PriceMatrixLocationWM {
	eventBaseId: number;

	isPrimary: boolean;
	holidaySurcharge?: number;
	holidaySurchargeType?: HolidaySurchargeType;

	minDistance?: number;
	perDistance?: number;
	maxDistance?: number;

	minTravel?: number;
	perTravel?: number;
	maxTravel?: number;

	items?: PriceMatrixItemWM[];
}

export class PriceMatrixItemWM {
	minAttendees?: number;
	maxAttendees?: number;
	resources?: number;
	daysOfWeek?: DaysOfWeek[];

	flatRate?: number;
	attendeeRate?: number;
	durationRate?: number;
	distanceRate?: number;
	travelRate?: number;
}

export class QuoteRequest {
	eventOn?: Moment | string;
	attendees?: number;
	duration?: number;
	resources?: number;
	location?: GeoLocation;
}

export enum QuoteState {
	Invalid = 0,
	Incomplete = 1,
	Complete = 2,
}

export enum QuoteParameter {
	Attendee = 1,
	Duration = 2,
	Resource = 3,
	Location = 4,
	Date = 5
}

export enum QuoteInvalidReason {
	// Exceeded Matrix Allowances - Invalid Input
	UnsupportedCurrency = 1,
	AttendeesTooFew = 2,
	AttendeesTooMany = 3,
	AttendeesUnsupported = 4,
	ResourcesTooFew = 5,
	ResourcesTooMany = 6,
	ResourcesUnsupported = 7,
	DurationTooShort = 8,
	DurationTooLong = 9,
	OutOfServiceArea = 10,
	DayOfWeekUnsupported = 11,
	// Matrix/Server has issue - Error
	InvalidMatrix = 1000,
	GoogleDistanceApiFailure = 1001,
	InvalidMatrixQuoteCalculation = 1002
}

export class Quote {
	state: QuoteState;

	travelSurcharge?: number;
	holidaySurcharge?: number;
	totalAmount?: number;
	currencyCode?: string;

	isHoliday?: boolean;
	location?: GeoLocation;
	travelDuration?: number;
	travelDistance?: number;

	invalidReason?: QuoteInvalidReason;
	missingParameters?: QuoteParameter[];
}

export class QuoteSummary {
	referenceNo: string;
	experienceName: string;
	experienceId: string;
	price: string;
	currencyCode: string;
	minAttendees: number;
	maxAttendees?: number;
	minResources?: number;
	maxResources?: number;
	pickUpAddress?: string;
	eventAddress?: string;
	eventOn: Moment | string;
	duration?: string;
	customerName: string;
	customerEmail: string;
	isRequestToBook: boolean;
	experienceContactNumber: string;
}
